.root {
  inset: 0;
  position: absolute;
  background: var(--overlay-bg, rgba(0, 0, 0, 0.6));
  -webkit-backdrop-filter: var(--overlay-filter);
  backdrop-filter: var(--overlay-filter);
  border-radius: var(--overlay-radius, 0);
  z-index: var(--overlay-z-index);

  &:where([data-fixed]) {
    position: fixed;
  }

  &:where([data-center]) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
